'use es6';

import actionTypes from '../constants/actionTypes';
const {
  HISTORY_METHOD_CALLED
} = actionTypes;
const createAction = method => location => ({
  type: HISTORY_METHOD_CALLED,
  payload: {
    method,
    args: [location]
  }
});
export const push = createAction('push');
export const goBack = createAction('goBack');